import { render, staticRenderFns } from "./games-select-input-keyword.vue?vue&type=template&id=58156488&scoped=true&"
import script from "./games-select-input-keyword.vue?vue&type=script&lang=js&"
export * from "./games-select-input-keyword.vue?vue&type=script&lang=js&"
import style0 from "./games-select-input-keyword.vue?vue&type=style&index=0&id=58156488&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58156488",
  null
  
)

export default component.exports